import { render, staticRenderFns } from "./TypeFilePPTIcon.vue?vue&type=template&id=4c1fcc0c&"
import script from "./TypeFilePPTIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFilePPTIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports